import queryString from 'query-string';
import verifyAuthRequest from './verifyAuthRequest';

/**
 * 인증 완료 후 쿼리를 파싱하고 백엔드 서버에게 인증 정보 검증을 요청하는 함수
 * @param {Number} authType 
 * @param {String} data 
 */
async function parseQueryAndVerifyAuthRequest(authType, data = '') {
  // 로딩 단계
  this.setState({
    verificationResult: false,
    statusCode: 'Loading',
    description: 'Loading ... Please wait ...',
  });

  // 인증 완료 후 얻은 쿼리를 파싱함
  const { state, code, error, message } = queryString.parse(this.props.location.search);

  // 쿼리에 state, code 가 있을 경우
  if (state && code) {
    try {
      // Backend 서버의 API 호출
      const res = await verifyAuthRequest(state, code, authType, data)
      this.setState({
        verificationResult: true,
        statusCode: 'Success',
        description: 'Verification success'
      });
      return res;
    } catch (err) {
      this.setState({
        verificationResult: false,
        statusCode: (err.status) ? 'CODE: ' + err.status : 'Unknown error',
        description: err.message,
      });
    }
  } else if (error && message) { // Query 에 error, message 가 있을 경우
    this.setState({
      verificationResult: false,
      statusCode: 'CODE: ' + error,
      description: message,
    });
  } else { // Query 가 사전에 정의된 형식이 아닌 경우
    this.setState({
      verificationResult: false,
      statusCode: 'Invalid query',
      description: 'Query string does\'t have state or code or error or message',
    });
  }
}

export default parseQueryAndVerifyAuthRequest;
